import { useEffect } from 'react';

const usePageLoadEvent = (eventName, data) => {
  useEffect(() => {
    window.__ADD_EVENT__(eventName, data);
  }, []);
};

export default usePageLoadEvent;
